import {
  Component,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'landing-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextComponent {
  @Input() type = 'h1';
  @Input() color = 'black';
  @Input() classes = '';

  getClasses() {
    return {
      [this.type]: true,
      [this.classes]: true,
      [this.color]: true
    };
  }
}
